import { useEffect, useState } from "react";
import { fyaiDefaultConfig } from "@/mocks/fyai-config";

export type FyaiDownloadLinks = {
  android: string;
  ios: string;
  harmonyos: string;
  windows: string;
};

export type FyaiConfig = {
  officialUrl: string;
  domain: string;
  contactEmail: string;
  downloadLinks: FyaiDownloadLinks;
};

export function useFyaiConfig(): FyaiConfig {
  const [config, setConfig] = useState<FyaiConfig>(fyaiDefaultConfig);

  useEffect(() => {
    let alive = true;
    const url = `${import.meta.env.BASE_URL}fyai-config.json`;
    fetch(url, { cache: "no-store" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!alive || !data) return;
        setConfig({
          officialUrl: data.officialUrl || fyaiDefaultConfig.officialUrl,
          domain: data.domain || fyaiDefaultConfig.domain,
          contactEmail: data.contactEmail || fyaiDefaultConfig.contactEmail,
          downloadLinks: {
            ...fyaiDefaultConfig.downloadLinks,
            ...(data.downloadLinks || {}),
          },
        });
      })
      .catch(() => {
        /* 读取失败时保留默认配置，保证页面可用 */
      });
    return () => {
      alive = false;
    };
  }, []);

  return config;
}